<template>
  <input
      class="form-control text-right"
      ref="inputRef"
      :value="formattedValue"
  />
</template>

<script>
import useCurrencyInput from 'vue-currency-input'
import {watch} from '@vue/composition-api'

export default {
  name: 'CurrencyInput',
  props: {
    modelValue: Number, // Vue 2: value
    options: Object
  },
  setup (props) {
    const { formattedValue, inputRef, setValue, setOptions} = useCurrencyInput(props.options)

    watch(() => props.modelValue, (value) => { // Vue 2: props.value
      setValue((value == null ? 0:value))
    })

    watch(() => props.options, (options) => {
      setOptions(options)
    })
    return { inputRef, formattedValue }
  }
}
</script>
